import React from "react";
import { FaCartArrowDown, FaWarehouse, FaTable } from "react-icons/fa";
import {
  AiOutlineHome,
  AiFillFile,
  AiFillDatabase,
  AiFillFileAdd,
} from "react-icons/ai";
import { MdLocalShipping, MdOutlineGroup } from "react-icons/md";
import { MdRepeat } from "react-icons/md";
import { IoMdAppstore } from "react-icons/io";
import { BsPieChartFill } from "react-icons/bs";
import {
  BsFillArrowDownCircleFill,
  BsFillArrowUpCircleFill,
} from "react-icons/bs";
import { RiShip2Fill } from "react-icons/ri";
import { BiTransfer } from "react-icons/bi";
import { GiAustralia } from "react-icons/gi";

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/",
    icon: <AiOutlineHome />,
  },

  {
    title: "Sales Orders",
    path: "/salesOrders",
    icon: <AiFillFile />,
    iconClosed: <BsFillArrowDownCircleFill />,
    iconOpened: <BsFillArrowUpCircleFill />,
    sub: true,
    subNav: [
      {
        title: "Create Sales Order",
        path: "/salesOrders/newOrder",
        icon: <AiFillFileAdd />,
      },
      {
        title: "All Sales Orders",
        path: "/salesOrders",
        icon: <FaTable />,
      },
      {
        title: "Recurring Orders",
        path: "/scheduledOrders",
        icon: <MdRepeat />,
      },
      {
        title: "Pickup Orders",
        path: "/pickupOrders",
        icon: <GiAustralia />,
      },
      {
        title: "Completed Orders",
        path: "/completedOrders",
        icon: <BsPieChartFill />,
      },
      {
        title: "Stock Change History",
        path: "/stockHistory",
        icon: <BiTransfer />,
      },
    ],
  },
  {
    title: "Deliveries",
    path: "/deliveries",
    icon: <MdLocalShipping />,
    iconClosed: <BsFillArrowDownCircleFill />,
    iconOpened: <BsFillArrowUpCircleFill />,
    sub: true,
    subNav: [
      {
        title: "New Deliveries",
        path: "/deliveries/createDeliveries",
        icon: <AiFillFileAdd />,
      },
      {
        title: "All Deliveries",
        path: "/deliveries",
        icon: <FaTable />,
      },
      {
        title: "Completed Deliveries",
        path: "/deliveries/CompletedDeliveries",
        icon: <BsPieChartFill />,
      },
    ],
  },
  {
    title: "Stock Control",
    path: "/stockControl",
    icon: <AiFillDatabase />,
  },
  {
    title: "Shipments",
    path: "/shipments",
    icon: <RiShip2Fill />,
    iconClosed: <BsFillArrowDownCircleFill />,
    iconOpened: <BsFillArrowUpCircleFill />,
    sub: true,
    subNav: [
      {
        title: "All Shipments",
        path: "/allShipments",
        icon: <FaTable />,
      },
      {
        title: "Completed Shipments",
        path: "/completedShipments",
        icon: <BsPieChartFill />,
      },
    ],
  },
  {
    title: "Contacts",
    path: "/customers",
    icon: <MdOutlineGroup />,
    iconClosed: <BsFillArrowDownCircleFill />,
    iconOpened: <BsFillArrowUpCircleFill />,
    sub: true,
    subNav: [
      {
        title: " New Contact",
        path: "/customers/newCustomer",
        icon: <AiFillFileAdd />,
      },
      {
        title: "All Contacts",
        path: "/customers",
        icon: <FaTable />,
      },
    ],
  },
  {
    title: "Products",
    path: "/products",
    icon: <FaCartArrowDown />,
    iconClosed: <BsFillArrowDownCircleFill />,
    iconOpened: <BsFillArrowUpCircleFill />,
    sub: true,
    subNav: [
      {
        title: "New Product",
        path: "/products/Addnewproducts",
        icon: <AiFillFileAdd />,
      },
      {
        title: "All Products",
        path: "/products",
        icon: <FaTable />,
      },
    ],
  },
  {
    title: "Warehouse",
    path: "/Warehouse",
    icon: <FaWarehouse />,
  },

  {
    title: "Apps",
    path: "/apps",
    icon: <IoMdAppstore />,
  },
  {
    title: "Runs",
    path: "/runs",
    icon: <AiOutlineHome />,
  },
  {
    title: "Warehouse Prep",
    path: "/warehousePrepare",
    icon: <AiOutlineHome />,
  },
];
